import { render, staticRenderFns } from "./subsidyDetails.vue?vue&type=template&id=43ddc3f6&"
import script from "./subsidyDetails.vue?vue&type=script&lang=js&"
export * from "./subsidyDetails.vue?vue&type=script&lang=js&"
import style0 from "./subsidyDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports